import { defineMessages } from 'react-intl';

const filterMessages = defineMessages({
  type: {
    id: 'search-filter.product-type',
    defaultMessage: 'Product Type',
  },
  operating_system: {
    id: 'search-filter.operating-system',
    defaultMessage: 'Operating System',
  },
  steam_deck_support: {
    id: 'search-filter.genres',
    defaultMessage: 'Steam Deck',
  },
  platform: {
    id: 'search-filter.platform',
    defaultMessage: 'Platform',
  },
  genre: {
    id: 'search-filter.genre',
    defaultMessage: 'Genre',
  },
  publishers: {
    id: 'search-filter.publisher',
    defaultMessage: 'Publishers',
  },
  features: {
    id: 'search-filter.features',
    defaultMessage: 'Features',
  },
  vrfeatures: {
    id: 'search-filter.vrfeatures',
    defaultMessage: 'VR Features',
  },
  onsale: {
    id: 'search-filter.onsale',
    defaultMessage: 'On Sale',
  },
  ondiscount: {
    id: 'search-filter.ondiscount',
    defaultMessage: 'Discounted',
  },
  offers: {
    id: 'search-filter.offers',
    defaultMessage: 'Offers',
  },
  categories: {
    id: 'search-filter.categories',
    defaultMessage: 'Categories',
  },
  themes: {
    id: 'search-filter.themes',
    defaultMessage: 'Themes',
  },
  playstyles: {
    id: 'search-filter.playstyles',
    defaultMessage: 'Playstyles',
  },
  languages: {
    id: 'search-filter.languages',
    defaultMessage: 'Languages',
  },
  collections: {
    id: 'search-filter.collections',
    defaultMessage: 'Collections',
  },
  price: {
    id: 'search-filter.price',
    defaultMessage: 'Price',
  },
  game: {
    id: 'type-filter.game',
    defaultMessage: 'game',
  },
  dlc: {
    id: 'type-filter.dlc',
    defaultMessage: 'DLC',
  },
  bundle: {
    id: 'type-filter.bundle',
    defaultMessage: 'bundle',
  },
  comic: {
    id: 'type-filter.comic',
    defaultMessage: 'comic',
  },
  book: {
    id: 'type-filter.book',
    defaultMessage: 'book',
  },
  software: {
    id: 'type-filter.software',
    defaultMessage: 'software',
  },
  elearning: {
    id: 'type-filter.elearning',
    defaultMessage: 'eLearning course',
  },
  audio: {
    id: 'type-filter.audio',
    defaultMessage: 'audio',
  },
  video: {
    id: 'type-filter.video',
    defaultMessage: 'video',
  },
  'comic-bundle': {
    id: 'type-filter.comic-bundle',
    defaultMessage: 'comic bundle',
  },
  'book-bundle': {
    id: 'type-filter.book-bundle',
    defaultMessage: 'book bundle',
  },
  'elearning-bundle': {
    id: 'type-filter.elearning-bundle',
    defaultMessage: 'eLearning bundle',
  },
  'software-bundle': {
    id: 'type-filter.software-bundle',
    defaultMessage: 'software bundle',
  },
  'audio-bundle': {
    id: 'type-filter.audio-bundle',
    defaultMessage: 'audio bundle',
  },
  singleplayer: {
    id: 'featuresfilter.singleplayer',
    defaultMessage: 'Single Player',
  },
  multiplayer: {
    id: 'featuresfilter.multiplayer',
    defaultMessage: 'Multi Player',
  },
  'co-op': {
    id: 'featuresfilter.co-op',
    defaultMessage: 'Co-Op',
  },
  'online co-op': {
    id: 'featuresfilter.onlineco-op',
    defaultMessage: 'Online Co-Op',
  },
  'local co-op': {
    id: 'featuresfilter.localco-op',
    defaultMessage: 'Local Co-Op',
  },
  'steam trading cards': {
    id: 'featuresfilter.steamtradingcards',
    defaultMessage: 'Steam trading cards',
  },
  'full controller support': {
    id: 'featuresfilter.fullcontrollersupport',
    defaultMessage: 'Full controller support',
  },
  'partial controller support': {
    id: 'featuresfilter.partialcontrollersupport',
    defaultMessage: 'Partial controller support',
  },
  'vr support': {
    id: 'featuresfilter.vrsupport',
    defaultMessage: 'VR support',
  },
  'free to play': {
    id: 'featuresfilter.freetoplay',
    defaultMessage: 'Free to play',
  },
  'steam achievements': {
    id: 'featuresfilter.steamachievements',
    defaultMessage: 'Steam achievements',
  },
  'trading cards': {
    id: 'featuresfilter.tradingcards',
    defaultMessage: 'Trading cards',
  },
  verified: {
    id: 'steamdeckfilter.verified',
    defaultMessage: 'Verified',
  },
  playable: {
    id: 'steamdeckfilter.playable',
    defaultMessage: 'Playable',
  },
  valve_index: {
    id: 'search.vr_features.valve_index',
    defaultMessage: 'Valve Index',
  },
  htc_vive: {
    id: 'search.vr_features.htc_vive',
    defaultMessage: 'HTC Vive',
  },
  oculus_rift: {
    id: 'search.vr_features.oculus_rift',
    defaultMessage: 'Oculus Rift',
  },
  oculus_meta_quest: {
    id: 'search.vr_features.oculus_meta_quest',
    defaultMessage: 'Meta Quest',
  },
  oculus_meta_quest_two: {
    id: 'search.vr_features.oculus_meta_quest_two',
    defaultMessage: 'Meta Quest 2',
  },
  oculus_meta_quest_three: {
    id: 'search.vr_features.oculus_meta_quest_three',
    defaultMessage: 'Meta Quest 3',
  },
  windows_mixed_reality: {
    id: 'search.vr_features.windows_mixed_reality',
    defaultMessage: 'Windows Mixed Reality',
  },
  tracked_motion_controllers: {
    id: 'search.vr_features.tracked_motion_controllers',
    defaultMessage: 'Tracked Motion Controllers',
  },
  gamepad: {
    id: 'search.vr_features.gamepad',
    defaultMessage: 'Gamepad',
  },
  keyboard_mouse: {
    id: 'search.vr_features.keyboard_mouse',
    defaultMessage: 'Keyboard / Mouse',
  },
  seated: {
    id: 'search.vr_features.seated',
    defaultMessage: 'Seated',
  },
  standing: {
    id: 'search.vr_features.standing',
    defaultMessage: 'Standing',
  },
  room_scale: {
    id: 'search.vr_features.room_scale',
    defaultMessage: 'Room Scale',
  },
  vr_required: {
    id: 'search.vr_features.vr_required',
    defaultMessage: 'VR Required',
  },
  price_label: {
    id: 'refinement.pricelabel',
    defaultMessage: 'Price: {filteredPrice}',
  },
  'gift-card': {
    id: 'refinement.giftcard',
    defaultMessage: 'Gift Card',
  },
});

export default filterMessages;
